import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  height?: string;
}

// Configuration des modules Quill avec les boutons que nous voulons
const modules = {
  toolbar: [
    // Formatage du texte
    ['bold', 'italic', 'underline', 'strike'],
    
    // Couleurs
    [{ 'color': [] }, { 'background': [] }],
    
    // Listes
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    
    // Alignement
    [{ 'align': [] }],
    
    // Titres
    [{ 'header': [1, 2, 3, false] }],
    
    // Liens et images
    ['link', 'image'],
    
    // Nettoyage
    ['clean'],
  ],
};

const formats = [
  'bold', 'italic', 'underline', 'strike',
  'color', 'background',
  'list', 'bullet',
  'align',
  'header',
  'link', 'image',
];

export const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  placeholder = 'Écrivez votre contenu ici...',
  height = '300px',
}) => {
  // Calculer la hauteur de l'éditeur en soustrayant la hauteur de la toolbar (~42px)
  const editorHeight = `calc(${height} - 42px)`;
  
  return (
    <div className="rich-text-editor" style={{ height, position: 'relative', zIndex: 0, display: 'flex', flexDirection: 'column' }}>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
      />
      <style>{`
        .rich-text-editor {
          display: flex;
          flex-direction: column;
        }
        .rich-text-editor .ql-toolbar {
          z-index: 1;
          flex-shrink: 0;
        }
        .rich-text-editor .ql-container {
          z-index: 0;
          flex: 1;
          height: ${editorHeight};
          overflow-y: auto;
        }
        .rich-text-editor .ql-editor {
          min-height: 100%;
        }
      `}</style>
    </div>
  );
};
